const qrCodeFrames = [
  {
    textClassName: 'qr-frame',
    hasText: true,
    value: '1',
    template: '1.svg',
    has_second_color: false,
    // qrParams: {x: 0, y: 0, width: 200, height: 200},
  },
  {
    textClassName: 'qr-frame',
    hasText: true,
    value: '2',
    template: '2.svg',
    has_second_color: false,
    // qrParams: {x: 0, y: 0, width: 200, height: 200},
  },
  {
    textClassName: 'dark-or-light',
    hasText: true,
    value: '3',
    template: '3.svg',
    has_second_color: false,
    // qrParams: {x: 0, y: 0, width: 200, height: 200},
  },
  {
    textClassName: 'dark-or-light',
    hasText: true,
    value: '4',
    template: '4.svg',
    has_second_color: false,
    // qrParams: {x: 0, y: 0, width: 30, height: 30},
  },
  {
    textClassName: 'dark-or-light',
    hasText: true,
    value: '5',
    template: '5.svg',
    has_second_color: false,
    // qrParams: {x: 0, y: 0, width: 50, height: 50},
  },
  {
    textClassName: 'dark-or-light',
    hasText: true,
    value: '6',
    template: '6.svg',
    has_second_color: false,
    // qrParams: {x: 0, y: 0, width: 50, height: 50},
  },
  {
    textClassName: 'dark-or-light-2',
    hasText: true,
    value: '7',
    template: '7.svg',
    has_second_color: true,
    // qrParams: {x: 0, y: 0, width: 50, height: 50},
  },
  {
    textClassName: 'dark-or-light',
    hasText: true,
    value: '8',
    template: '8.svg',
    has_second_color: false,
    // qrParams: {x: 0, y: 0, width: 50, height: 50},
  },
  {
    textClassName: 'dark-or-light',
    hasText: true,
    value: '9',
    template: '9.svg',
    has_second_color: true,
    // qrParams: {x: 0, y: 0, width: 50, height: 50},
  },
  {
    textClassName: 'dark-or-light',
    hasText: true,
    value: '10',
    template: '10.svg',
    has_second_color: false,
    // qrParams: {x: 0, y: 0, width: 50, height: 50},
  },
  {
    textClassName: 'dark-or-light',
    hasText: true,
    value: '11',
    template: '11.svg',
    has_second_color: true,
    // qrParams: {x: 0, y: 0, width: 50, height: 50},
  },
  {
    textClassName: 'dark-or-light-2',
    hasText: true,
    value: '12',
    template: '12.svg',
    has_second_color: true,
    // qrParams: {x: 0, y: 0, width: 50, height: 50},
  },
  {
    textClassName: 'dark-or-light-2',
    hasText: true,
    value: '13',
    template: '13.svg',
    has_second_color: true,
    // qrParams: {x: 0, y: 0, width: 50, height: 50},
  },
  {
    textClassName: 'qr-frame',
    hasText: true,
    value: '14',
    template: '14.svg',
    has_second_color: false,
    // qrParams: {x: 0, y: 0, width: 50, height: 50},
  },
  {
    textClassName: 'dark-or-light',
    hasText: true,
    value: '15',
    template: '15.svg',
    has_second_color: true,
    // qrParams: {x: 0, y: 0, width: 200, height: 200},
  },
  {
    textClassName: 'qr-frame',
    hasText: true,
    value: '16',
    template: '16.svg',
    has_second_color: false,
    // qrParams: {x: 0, y: 0, width: 200, height: 200},
  },
  {
    textClassName: 'dark-or-light',
    hasText: true,
    value: '17',
    template: '17.svg',
    has_second_color: true,
    // qrParams: {x: 0, y: 0, width: 200, height: 200},
  },
  {
    textClassName: 'dark-or-light',
    hasText: true,
    value: '18',
    template: '18.svg',
    has_second_color: false,
    // qrParams: {x: 0, y: 0, width: 200, height: 200},
  },
  {
    textClassName: 'dark-or-light',
    hasText: true,
    value: '19',
    template: '19.svg',
    has_second_color: false,
    // qrParams: {x: 0, y: 0, width: 200, height: 200},
  },
  {
    textClassName: 'dark-or-light',
    hasText: true,
    value: '20',
    template: '20.svg',
    has_second_color: false,
    // qrParams: {x: 0, y: 0, width: 200, height: 200},
  },
  {
    textClassName: 'dark-or-light',
    hasText: true,
    value: '21',
    template: '21.svg',
    has_second_color: true,
    // qrParams: {x: 0, y: 0, width: 200, height: 200},
  },
  {
    textClassName: 'dark-or-light',
    hasText: true,
    value: '22',
    template: '22.svg',
    has_second_color: false,
    // qrParams: {x: 0, y: 0, width: 200, height: 200},
  },
  {
    textClassName: 'dark-or-light',
    hasText: true,
    value: '23',
    template: '23.svg',
    has_second_color: false,
    // qrParams: {x: 0, y: 0, width: 200, height: 200},
  },
  {
    textClassName: 'qr-frame',
    hasText: true,
    value: '24',
    template: '24.svg',
    has_second_color: false,
    // qrParams: {x: 0, y: 0, width: 200, height: 200},
  },
  {
    textClassName: 'qr-frame',
    hasText: true,
    value: '25',
    template: '25.svg',
    has_second_color: false,
    // qrParams: {x: 0, y: 0, width: 200, height: 200},
  },
]
const qrCodeLogo = [
  {value: 'facebook', key: 'project_files/generator/logo/facebook.png'},
  {value: 'twitter', key: 'project_files/generator/logo/twitter.png'},
  {value: 'linkedin', key: 'project_files/generator/logo/linkedin.png'},
  {value: 'telegram', key: 'project_files/generator/logo/telegram.png'},
  {value: 'youtube', key: 'project_files/generator/logo/youtube.png'},
  {value: 'tiktok', key: 'project_files/generator/logo/tiktok.png'},
  {value: 'whatapp', key: 'project_files/generator/logo/whatapp.png'},
  {value: 'spotify', key: 'project_files/generator/logo/spotify.png'},
  {value: 'yelp', key: 'project_files/generator/logo/yelp.png'},
  {value: 'pinterest', key: 'project_files/generator/logo/pinterest.png'},
  {value: 'skype', key: 'project_files/generator/logo/skype.png'},
  {value: 'tumblr', key: 'project_files/generator/logo/tumblr.png'},
  {value: 'snapchat', key: 'project_files/generator/logo/snapchat.png'},
  {value: 'reddit', key: 'project_files/generator/logo/reddit.png'},
  {value: 'meetup', key: 'project_files/generator/logo/meetup.png'},
  {value: 'quora', key: 'project_files/generator/logo/quora.png'},
  {value: 'medium', key: 'project_files/generator/logo/medium.png'},
  {value: 'twitch', key: 'project_files/generator/logo/twitch.png'},
  {value: 'signal', key: 'project_files/generator/logo/signal.png'},
  {value: 'viber', key: 'project_files/generator/logo/viber.png'},
  {value: 'kakao-talk', key: 'project_files/generator/logo/kakao-talk.png'},
  {value: 'patreon', key: 'project_files/generator/logo/patreon.png'},
  {value: 'sound-cloud', key: 'project_files/generator/logo/sound-cloud.png'},
  {value: 'apple-podcast', key: 'project_files/generator/logo/apple-podcast.png'},
  {value: 'shopify', key: 'project_files/generator/logo/shopify.png'},
  {value: 'etsy', key: 'project_files/generator/logo/etsy.png'},
  {value: 'ebay', key: 'project_files/generator/logo/ebay.png'},
  {value: 'instagram', key: 'project_files/generator/logo/instagram.png'},
  {value: 'amazon', key: 'project_files/generator/logo/amazon.png'},
  {value: 'gmail', key: 'project_files/generator/logo/gmail.png'},
  {value: 'armchair', key: 'project_files/generator/logo/armchair.png'},
  {value: 'bar', key: 'project_files/generator/logo/bar.png'},
  {value: 'burger', key: 'project_files/generator/logo/burger.png'},
  {value: 'cake', key: 'project_files/generator/logo/cake.png'},
  {value: 'coffee', key: 'project_files/generator/logo/coffee.png'},
  {value: 'corn', key: 'project_files/generator/logo/corn.png'},
  {value: 'earth2', key: 'project_files/generator/logo/earth2.png'},
  {value: 'earth', key: 'project_files/generator/logo/earth.png'},
  {value: 'gift', key: 'project_files/generator/logo/gift.png'},
  {value: 'gmap', key: 'project_files/generator/logo/gmap.png'},
  {value: 'google-play', key: 'project_files/generator/logo/google-play.png'},
  {value: 'laptop', key: 'project_files/generator/logo/laptop.png'},
  {value: 'paypal', key: 'project_files/generator/logo/paypal.png'},
  {value: 'scan', key: 'project_files/generator/logo/scan.png'},
  {value: 'scan2', key: 'project_files/generator/logo/scan2.png'},
  {value: 'scan3', key: 'project_files/generator/logo/scan3.png'},
  {value: 'tent', key: 'project_files/generator/logo/tent.png'},
  {value: 'train', key: 'project_files/generator/logo/train.png'},
  {value: 'wifi', key: 'project_files/generator/logo/wifi.png'},
  {value: 'wifi2', key: 'project_files/generator/logo/wifi2.png'},
  {value: 'wifi3', key: 'project_files/generator/logo/wifi3.png'},
  {value: 'gdoc', key: 'project_files/generator/logo/gdoc.png'},
]
const qrCodeMarkers = [
  {value: 'marker-1', template: 'marker-1.svg'},
  {value: 'marker-2', template: 'marker-2.svg'},
  {value: 'marker-3', template: 'marker-3.svg'},
  {value: 'marker-4', template: 'marker-4.svg'},
  {value: 'marker-5', template: 'marker-5.svg'},
  {value: 'marker-6', template: 'marker-6.svg'},
  {value: 'marker-7', template: 'marker-7.svg'},
  {value: 'marker-8', template: 'marker-8.svg'},
  {value: 'marker-9', template: 'marker-9.svg'},
  {value: 'marker-10', template: 'marker-10.svg'},
  {value: 'marker-11', template: 'marker-11.svg'},
  {value: 'marker-12', template: 'marker-12.svg'},
  {value: 'marker-13', template: 'marker-13.svg'},
  {value: 'marker-14', template: 'marker-14.svg'},
]
module.exports = {
  qrCodeMarkers,
  qrCodeFrames,
  qrCodeLogo,
}